import React from "react";
import { Link } from "react-router-dom";
import CustomButton from "../Button/CustomButton";
import Logo from "../Logo/Logo";
import Search from "../Search/Search";
import styles from "./Navbar.module.css";

function Navbar({ searchData }) {
  return (
    <nav className={styles.navbar}>
      <Link to="/">
        <Logo />
      </Link>
      <Search
        placeholder="Search a song of your choice"
        searchData={searchData}
      />
      <CustomButton>Give Feedback</CustomButton>
    </nav>
  );
}

export default Navbar;
